import { label } from '../lib/format';

export function Pill({ value, tone = 'neutral' }: { value: string; tone?: 'neutral' | 'accent' | 'positive' | 'warning' }) {
  return <span className={`pill pill--${tone}`}>{label(value)}</span>;
}
